module.exports = __webpack_public_path__ + "img/hom_no.49ddb618.png";